<template>
  <div
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
          >
            Edit Part
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <part-form :entity="part" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PartForm } from '../../../forms';

export default {
  name: 'EditPartModal',
  components: { PartForm },
  props: {
    part: {
      type: Object,
      default: () => null
    }
  }
};
</script>
